import React, { useState, useEffect } from "react";
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import FiltersPartial from './FiltersPartial.js'
import { updateQueryParams, selectQueryParams } from "../../ui/customerListingReducer";
import { useSelector } from "react-redux";

const Index = () => {
  const defaultHeaderConfig = { disableSort: true };
  const params = useSelector(selectQueryParams);
  const [filtersModel, setFiltersModel] = useState({})

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false,
    },
    {
      ...defaultHeaderConfig,
      label: 'Serial Number',
      attr: 'serial_no',
      disableSort: false,
    },
    {
      ...defaultHeaderConfig,
      label: 'Scheme',
      attr: 'scheme',
    },
    {
      ...defaultHeaderConfig,
      label: 'Material Code',
      attr: 'inventory_code',
    },
    {
      ...defaultHeaderConfig,
      label: 'charging Station Model',
      attr: 'charging_station_model',
    },
    {
      ...defaultHeaderConfig,
      label: 'charging Station Type',
      attr: 'charging_station_type',
    },
    {
      ...defaultHeaderConfig,
      label: 'Owner',
      value: (row) => {
        return <div>
          {row.owner?.name} - {row.owner_type == "User" ? `CP${row.owner_id}` : row.owner_id} 
        </div>
      }
    },
    {
      ...defaultHeaderConfig,
      label: 'Charging Zone',
      attr: 'charging_zone_name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Firm Name',
      attr: 'firm_name',
    },
    
  ]

  return <>
    <ListingPageComponent
      key={PAGES.ChargingStationsListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.ChargingStationsListingPage.name)}
      breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Charging Station'}]}
      listingMutation={getApi('chargingStations')}
      className="charging-stations-listing-page"
      contentHeading="Charging Stations - Results"
      headers={headers}
      recordsKey="charging_stations"
      searchBy={['ID','Serial Number', 'Charging Zone Name']}
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
  />
  </>
};

export default Index;
